import React, { useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core';
import TableComponents from 'components/Table';
import { formatCurrency, formatPercent } from 'utils';
import { FundAllocationType } from 'store/modules/ExistingPolicies/types';
import ModelPortfolioAllocations from 'components/ModelPortfolio/ModelPortfolioAllocations';
import {
  getOverriddenCharges,
  initialiseOverrides
} from 'components/Policies/utils';

const { TableRow } = TableComponents;

const useStyles = makeStyles({
  boldRow: {
    fontWeight: 'bold',
    '& input': {
      fontWeight: 'bold'
    }
  },
  icon: {
    fontSize: '1.5rem',
    cursor: 'pointer',
    transition: '0.3s'
  }
});

interface Props {
  fundInstance: FundAllocationType;
}

const Fund = ({ fundInstance }: Props) => {
  const [isModelPortfolioExpanded, setModelPortfolioExpanded] = useState(false);
  const classes = useStyles();

  const { fund_value, allocation, fund, model_portfolio } = fundInstance;

  const overrides = initialiseOverrides(fundInstance, false);

  const isModelPortfolio = model_portfolio;

  const {
    sector_name,
    ocf,
    three_y_performace,
    one_y_performace,
    five_y_performace,
    trading_costs
  } = isModelPortfolio ? model_portfolio : fund;

  const { fundOcf, fundTradingCosts, customTotalFundCharge } =
    getOverriddenCharges(
      overrides,
      model_portfolio,
      Number(ocf),
      Number(trading_costs),
      1
    );

  const formatedOCF = fundOcf ? formatPercent(Number(fundOcf) * 100) : '-';
  const formated1Yr = one_y_performace
    ? formatPercent(Number(one_y_performace) * 100, true)
    : '-';
  const formated3Yr = three_y_performace
    ? formatPercent(Number(three_y_performace) * 100, true)
    : '-';
  const formated5Yr = five_y_performace
    ? formatPercent(Number(five_y_performace) * 100, true)
    : '-';

  const formatedTransactionCosts = fundTradingCosts
    ? formatPercent(Number(fundTradingCosts) * 100)
    : '-';

  return (
    <>
      <TableRow>
        <TableComponents.TableCell
          className={isModelPortfolio && classes.boldRow}
        >
          {isModelPortfolio ? model_portfolio.name : fundInstance.fund.name}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="160px"
          className={isModelPortfolio && classes.boldRow}
        >
          {sector_name}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="100px"
          className={isModelPortfolio && classes.boldRow}
        >
          {fund_value ? formatCurrency(fund_value) : '-'}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="80px"
          className={isModelPortfolio && classes.boldRow}
        >
          {allocation ? formatPercent(Number(allocation) * 100) : '-'}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="70px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formatedOCF}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="70px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formatedTransactionCosts}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="100px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formatPercent(customTotalFundCharge * 100)}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="80px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formated1Yr}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="80px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formated3Yr}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="80px"
          className={isModelPortfolio && classes.boldRow}
        >
          {formated5Yr}
        </TableComponents.TableCell>
        <TableComponents.TableCell
          width="60px"
          className={isModelPortfolio && classes.boldRow}
        >
          {isModelPortfolio && (
            <ExpandMoreIcon
              width="20px"
              className={classes.icon}
              onClick={() =>
                setModelPortfolioExpanded(!isModelPortfolioExpanded)
              }
              style={{
                transform: isModelPortfolioExpanded
                  ? 'rotate(180deg)'
                  : 'rotate(0)'
              }}
            />
          )}
        </TableComponents.TableCell>
      </TableRow>
      {isModelPortfolio && isModelPortfolioExpanded && (
        <ModelPortfolioAllocations
          id={model_portfolio.id}
          fundAllocations={model_portfolio.fund_allocations}
          modelPortfolioFundValue={fund_value}
          overrides={overrides}
          overrideDivideBy={1}
        />
      )}
    </>
  );
};

export default Fund;
